class MoFooterMenus extends HTMLElement {
  connectedCallback() {
    if (this.media) return;
    this.buttons = Array.from(this.querySelectorAll('[data-mo-footer-toggle]'));
    if (!this.buttons.length) return;
    this.media = window.matchMedia('(max-width: 749px)');
    this.onBreakpoint = () => this.resetPanels();
    this.onClick = (event) => {
      const button = event.target.closest('[data-mo-footer-toggle]');
      if (!this.media.matches || !button || !this.buttons.includes(button)) return;
      const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
      this.buttons.forEach((other) => this.setPanel(other, other === button && shouldOpen));
    };
    this.addEventListener('click', this.onClick);
    this.media.addEventListener('change', this.onBreakpoint);
    this.classList.add('mo-footer-ready');
    this.resetPanels();
  }
  disconnectedCallback() {
    if (!this.media) return;
    this.removeEventListener('click', this.onClick);
    this.media.removeEventListener('change', this.onBreakpoint);
    this.media = null;
  }
  setPanel(button, open) {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel || !this.contains(panel)) return;
    button.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  }
  resetPanels() {
    this.buttons.forEach((button) => this.setPanel(button, !this.media.matches));
  }
}
if (!customElements.get('mo-footer-menus')) customElements.define('mo-footer-menus', MoFooterMenus);
